<template>
  <div class="system-page" id="app" style="overflow-y: scroll;">
    <mt-header :title="'附件详情'">
      <mt-button icon="back" slot="left" @click.native="goBack">返回</mt-button>
    </mt-header>
    <div v-if="isLoading" class="back-loading">数据加载中...</div>
    <div class="header" style="display: flex; align-items: center; padding: 0 0; background-color: #f5f5f5;position: sticky; top: 0">
      <div class="scrollable-content" id="scrollableContent" style="height: 600px;">
        <div style="width: 22rem;">
          <table class="bo table ">
            <tr>
              <td style="font-size: 20px;line-height: 22px;">
                文件名: {{ attachment.attachmentName }}
              </td>
            </tr>
            <tr>
              <td>
                <iframe :src="previewContent" width="100%" height="600px" frameborder="0"></iframe>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tabModule from "@/components/footerBar/index.vue";
import { getLocalData } from "@/utils/sessionData.js";
import request from "@/utils/keyCloakRequest";
import axios from "axios";
import {Indicator} from "mint-ui";
export default {
  components: {
    "v-tab-module": tabModule,
  },
  beforeMount() {},
  data() {
    return {
      attachment:{},
      previewContent:'',
      processId:'',
      item:{},
      route:'',
      name:'',
      userInfo: {},
      isLoading: false,
    };
  },
  async created() {
    this.userInfo = JSON.parse(getLocalData("userInfo"))
    this.item = this.$route.query.item;
    this.route =  this.$route.query.route
    this.attachment =  this.$route.query.attachment
    this.name =  this.$route.query.name
    this.previewFile()
  },
  mounted() {
  },

  methods: {
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, // 生成0-15之间的随机数
            v = c === 'x' ? r : (r & 0x3 | 0x8); // 对于'y'位置，确保首位是8, 9, A, B
        return v.toString(16); // 转换为16进制字符串
      });
    },
    previewFile(){
      var url = 'https://zfoabg.com/oa/downloadFile?fileid='+this.attachment.attachmentId; //要预览文件的访问地址
      console.log(url)
      var previewUrl = url + '&fullfilename='+this.generateUUID()+'.'+this.attachment.attachmentShuffix
      // this.previewContent = 'https://zfoabg.com/onlinePreview?url='+encodeURIComponent(btoa(previewUrl));
      this.previewContent = 'https://zfoabg.com/onlinePreview/onlinePreview?url='+encodeURIComponent(btoa(previewUrl));
      console.log(this.previewContent)
    },
    goBack() {
      this.$router.push({
        name: this.name,
        query: {
          item: this.item,
          route:this.route
        },
      });
    },
  },
};
</script>

<style lang="less">
@color: #ffffff;
@border-rd: 0.6rem;

html {
  overflow: hidden;
  height: 100%;
  background: #f5f5f5;
}

body {
  display: block;
  margin: 0rem !important;
}
.app {
  /* padding: 0.5rem; */
  background-color: rgb(240, 240, 240, 0.75);
}
.menuTitle {
  font-size: 1rem;
}
.system-page {
  width: 100%;
  height: 100vh;
  background-color: #f1f5f8;
  font-family: "PingFangSC-Regular";
}
/** 加载中 */
.back-loading {
  width: 100%;
  height: 100%;
  background-color: white;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  text-align: center;
  line-height: 25rem;
  font-size: 1rem;
  color: grey;
}
</style>
